import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from 'parse';
import Api from '../../Utils/api';
import Utils from '../../Utils/Utility';
import moment from 'moment-timezone';
import TableHolderCustom from './table-holder-custom';
import CONFIG_HELPER from "../../../ConfigHelper";
import LinearProgress from "material-ui/LinearProgress";
import {CSVDownload, CSVLink} from "react-csv";
import Modal from "../generic/modal";
import Search_Icon from "../../../img/prev.png";
import CustomerDetail from './../order/customer-detail';

const columns = {
    // 'customerName'        : {type : 'string',label : 'Customer'},
    'customerEmail': {type: 'string', label: 'Customer'},
    'lastOrderDate': {type: 'string', label: 'Last Order'},

    // 'lastOrderNum'        : {type : 'number',label : 'Last Order Num', prefix: '#'},
    // 'lastOrderTotal'      : {type : 'number',label : 'Last Order Total', prefix: '$'},
    'totalOrders': {type: 'number', label: 'Total Orders'},
    'orderTotal': {type: 'number', label: 'Total Amount', prefix: '$'},
    'customerDetails': {type: 'number', label: 'Details'}

    // 'totalPi  'totalAmountSpent'    : {type : 'number',label : 'Total Amount', prefix: '$'},ckupAmount'   : {type : 'number',label : 'PickUp Amount', prefix: '$'},
    // 'totalDeliveryAmount' : {type : 'number',label : 'Delivery Amount', prefix: '$'},
    // 'totalDineInAmount'   : {type : 'number',label : 'Dine-In Amount', prefix: '$'},
    // 'pickupOrders'        : {type : 'number',label : 'Pickup Orders'},
    // 'deliveryOrders'      : {type : 'number',label : 'Delivery Orders'},
    // 'dineInOrders'        : {type : 'number',label : 'Dine-In Orders'},
    // 'totalTipPaid'        : {type : 'number',label : 'Tip Amount', prefix: '$'},
    // 'customCharge'        : {type : 'string',label : 'Custom Charge'},
    // 'charge2'             : {type : 'number',label : 'Charge 2', prefix: '$'},
    // 'charge3'             : {type : 'number',label : 'Charge 3', prefix: '$'},
    // 'totalCouponUsed'     : {type : 'number',label : 'Coupons Used'},

}

// Export Header


const headerColumns = [
    {key: 'customerName', label: 'Name'},
    {key: 'customerEmail', label: 'Email'},
    {key: 'createdAt', label: 'Date Created'},
    {key: 'lastOrderDate', label: 'Last Order Date'},
    {key: 'lastOrderNum', label: 'Last Order Num'},
    {key: 'lastOrderTotal', label: 'Last Order Total'},
    {key: 'totalAmountSpent', label: 'Total Amount'},
    {key: 'pickupOrders', label: 'Pickup Orders'},
    {key: 'deliveryOrders', label: 'Delivery Orders'},
    {key: 'dineInOrders', label: 'Dine-In Orders'},
    {key: 'totalOrders', label: 'Total Orders'},
    {key: 'totalPickupAmount', label: 'PickUp Amount'},
    {key: 'totalDeliveryAmount', label: 'Delivery Amount'},
    {key: 'totalDineInAmount', label: 'Dine-In Amount'},
    {key: 'totalTipPaid', label: 'Tip Amount'},
    {key: 'customCharge', label: 'Custom Charge'},
    {key: 'totalCouponUsed', label: 'Coupons Used'}
];



export default class UserStats2Table extends Component {

    // contextTypes is used to pushed the routes in url
    static contextTypes = {
        router : React.PropTypes.object.isRequired
    }

    constructor(props){
        super(props);

        let timeZone    = localStorage.getItem("timeZone");
        moment.tz.setDefault(timeZone);

        this.state = {
            customersData        : [],
            isLoaded             : true,
            activeLocation       : null,
            isPrevBtnActive      : 'disabled',
            isNextBtnActive      : 'disabled',
            limit                : CONFIG_HELPER.DEFAULT_CUSTOMER_LIMIT,
            skip                 : 0,
            pagination           : false,
            totalCustomersCount  : 0,
            exportCustomersData  : [],
            exportLimit          : CONFIG_HELPER.DEFAULT_EXPORT_CUSTOMER_LIMIT,
            exportSkip           : 0,
            downloadCSVFile      : false,
            autoDownloadCSVFile  : false,
            progressBar          : false,
            CSVfileName          : "",
            errorMessage         : false,
            // completed            : 0,
            showExportModal      : false,
            showModalPopUp       : false,
            custumerDetails      : {},
            filterCustomersData  : {}
        };

        this._bind(
            'fetchUserStatsDetails',
            'btnPrevClick',
            'btnNextClick',
            'setPrevAndNextBtnClass',
            'parseCustomersData',
            'exportCustomerReport',
            'loadModalPopup',
            'hideModalPopUp'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    fetchUserStatsDetails(){

        if (!this.state.activeLocation) {
            return;
        }

        this.setState({
            isLoaded : false
        });

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let locId   = this.state.activeLocation.objectId;

        const businessDetail = currentUser.get("bizId");
        const bizId          = businessDetail.id;

        let limit = this.state.limit;
        let skip = this.state.skip;

        let self = this;

        Api.getUserStatsForLocId(userId, sessionToken, locId, limit, bizId, skip)
            .then((response) => {
                // console.log(JSON.stringify(response));
                self.parseCustomersData(response);
            },
                (error)=>{
                    // console.log("Error while fetching Order details !" + JSON.stringify(error));
                    // user session is invalid
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                });
    }

    parseCustomersData(customersResponseData){
        let self = this;
        if (customersResponseData.data && customersResponseData.data.length > 0) {
            const results = customersResponseData.data;

            this.setState({
                filterCustomersData: results
            })

            results.forEach(result => {

                /* Response Data*/
                let newTable = {};
                Object.keys(columns).forEach(col => {
                    if (col === "totalOrders") {
                        let totalOrders = ( Utils.getNum(result["deliveryOrders"]) + Utils.getNum(result["pickupOrders"])  + Utils.getNum(result["dineInOrders"]) );
                        newTable[col] = totalOrders;
                    }else if (col === "totalAmountSpent") {
                        let totalAmountSpent  = Utils.number2digit( Utils.getNum(result["totalDeliveryAmount"]) + Utils.getNum(result["totalPickupAmount"]) + Utils.getNum(result["totalDineInAmount"]) );
                        newTable[col] = totalAmountSpent;
                    }
                    else if (col === "totalDeliveryAmount") {
                        let totalDeliveryAmount = "";
                        if(!Utils.isEmpty(result["totalDeliveryAmount"]) && result["totalDeliveryAmount"] != null){
                            totalDeliveryAmount = Utils.number2digit(result["totalDeliveryAmount"]);
                        }
                        newTable[col] = totalDeliveryAmount;
                    }else if (col === "totalDineInAmount") {
                        let totalDineInAmount = "";
                        if(!Utils.isEmpty(result["totalDineInAmount"]) && result["totalDineInAmount"] != null){
                            totalDineInAmount = Utils.number2digit(result["totalDineInAmount"]);
                        }
                        newTable[col] = totalDineInAmount;
                    }else if (col === "totalTipPaid") {
                        let totalTipPaid = Utils.number2digit(result["totalTipPaid"]);
                        newTable[col] = totalTipPaid;
                    }
                    else if (col === "orderTotal") {
                        let orderTotal = Utils.number2digit( Utils.getNum(result["totalDeliveryAmount"]) + Utils.getNum(result["totalPickupAmount"]) + Utils.getNum(result["totalDineInAmount"]) );
                        newTable[col] = orderTotal;
                    }else if(col === "customerDetails"){
                        newTable[col] = result;
                    }else{
                        newTable[col] = result[col];
                    }
                });

                self.state.customersData.push(newTable);
            });

            self.setState({
                isLoaded: true,
                totalCustomersCount: customersResponseData.count
            },()=> {
                self.setPrevAndNextBtnClass();
            });

        } else {
            self.setState({
                isLoaded: true
            });
        }
    }

    setPrevAndNextBtnClass(){

        let skip = this.state.skip;
        let limit = this.state.limit;
        let skipLimit = skip + limit;
        let totalCount = this.state.totalCustomersCount;

        if (totalCount > limit){

            this.setState({pagination: true});

            if (skipLimit <=limit){
                this.setState({isPrevBtnActive: 'disabled'});
            }
            else {
                this.setState({isPrevBtnActive: ''});
            }

            if (skipLimit >= totalCount){
                this.setState({isNextBtnActive: 'disabled'});
            }
            else {
                this.setState({isNextBtnActive: ''});
            }
        }
        else {
            this.setState({pagination: false});
        }
    }

    btnPrevClick() {

        let skipLimit = this.state.skip - this.state.limit;
        this.setState({
            customersData:[],
            skip : skipLimit,
            // totalCustomersCount : 0
        },()=>{
            this.fetchUserStatsDetails();
        });

    }

    btnNextClick() {

        let skipLimit = this.state.skip + this.state.limit;
        this.setState({
            customersData:[],
            skip : skipLimit,
            // totalCustomersCount : 0
        },()=>{
            this.fetchUserStatsDetails();
        });
    }

    componentWillMount() {

        // if (!this.state.activeLocation) {
        //     return;
        // }


       let fileName = this.props.activeLocation.name ? (this.props.activeLocation.name).replace(/[\. ,:-]+/g, "") + "-customers" : "download-csv";

        this.setState({
            // google         : this.props.google,
            activeLocation : this.props.activeLocation,
            CSVfileName: fileName
        });
    }

    componentWillReceiveProps(nextProps) {

        let currentActiveLoc = this.props.activeLocation;
        let locId = "";

        if(currentActiveLoc) {
            locId = currentActiveLoc.objectId;
        }

        if(nextProps !== null
            &&
          nextProps.activeLocation !== null
            &&
          nextProps.activeLocation.objectId !== locId
        ) {
            let fileName = nextProps.activeLocation.name ? (nextProps.activeLocation.name).replace(/[\. ,:-]+/g, "") + "-customers" : "download-csv";

            this.setState({
                // google         : nextProps.google,
                activeLocation : nextProps.activeLocation,
                    customersData        : [],
                    skip                 : 0,
                    totalCustomersCount  : 0,
                    exportCustomersData  : [],
                    exportSkip           : 0,
                    CSVfileName: fileName
            },
            () => {
                this.fetchUserStatsDetails();
            });
        }
    }

    componentDidMount(){

        let self = this;
        Utils.isUserSessionInvalid().then((response) => {
            this.fetchUserStatsDetails();
        }, (error) => {
            // console.log("error user session: "+JSON.stringify(error));
            // user session is invalid
            Utils.checkErrorIsInvalidSessionToken(error, self.context.router);

        });
    }

    async exportCustomerReport() {

        this.showExportModal();

        this.setState({
            progressBar: true
        });

        // this.progress(0,10);

        let responseData = await this.fetchAndParseCustomerData();

    }

    async fetchAndParseCustomerData() {

        let skip = this.state.exportSkip;
        let limit = this.state.exportLimit;

        // call the api and fetch all the order records
        let responseData = await this.getExportCustomerData(skip);

        // parse the data
        let parseOrderDataResponse = await this.parseExportCustomerData(responseData);

        if (parseOrderDataResponse.error == false) {
            if (this.state.exportCustomersData.length < parseOrderDataResponse.data.totalCount) {

                // update progress bar
                // this.progress(parseOrderDataResponse.data.totalCount,null);

                // increase the skip count
                this.setState({
                    exportSkip: skip + limit
                });
                this.fetchAndParseCustomerData();

            } else if (this.state.exportCustomersData.length == parseOrderDataResponse.data.totalCount) {

                // completed progress bar
                // this.progress(parseOrderDataResponse.data.totalCount,100);

                this.setState({
                    progressBar: false,
                    autoDownloadCSVFile: true,
                    downloadCSVFile: true
                })
            }
        } else {
            this.setState({
                progressBar: false,
                errorMessage: true
            })
        }
    }

    getExportCustomerData(skip) {

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let locId   = this.state.activeLocation.objectId;

        const businessDetail = currentUser.get("bizId");
        const bizId          = businessDetail.id;

        let limit = this.state.exportLimit;
        // let skip = this.state.skip;

        let self = this;

        return Api.getUserStatsForLocId(userId, sessionToken, locId, limit, bizId, skip)
            .then((response) => {
                    return response;
                },
                (error) => {
                    console.log("Error while fetching Order details !" + JSON.stringify(error));
                    // user session is invalid
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                });

    }

    parseExportCustomerData(customerResponseData){

        if (customerResponseData.data && customerResponseData.data.length > 0) {

            const results = customerResponseData.data;

            results.forEach(result => {

                /* Response Data*/
                let newTable = {};

                // fetch all the columns and add logic
                headerColumns.map((rowVal, key) => {

                    // get key
                    let col = rowVal.key;

                    if (col === "lastOrderDate") {
                        let lastOrderDate = moment(result[col].iso);
                        let formattedDate = lastOrderDate.format("MMM Do YYYY, h:mm:ss a");
                        newTable[col] = formattedDate;
                    }else if (col === "createdAt") {
                        let createdAt = moment(result[col]);
                        let createdAtNew = createdAt.format("MMM Do YYYY, h:mm:ss a");
                        newTable[col] = createdAtNew;
                    }
                    else if (col === "totalOrders") {
                        let totalOrders = ( Utils.getNum(result["deliveryOrders"]) + Utils.getNum(result["pickupOrders"]) + Utils.getNum(result["dineInOrders"]) );
                        newTable[col] = totalOrders;
                    } else if (col === "totalAmountSpent") {
                        let totalAmountSpent  = Utils.number2digit( Utils.getNum(result["totalDeliveryAmount"]) + Utils.getNum(result["totalPickupAmount"]) + Utils.getNum(result["totalDineInAmount"]) );
                        newTable[col] = totalAmountSpent;
                    } else if (col === "totalPickupAmount") {
                        let totalPickupAmount = "";
                        if(!Utils.isEmpty(result["totalPickupAmount"]) && result["totalPickupAmount"] != null){
                            totalPickupAmount = Utils.number2digit(result["totalPickupAmount"]);
                        }
                        newTable[col] = totalPickupAmount;
                    }else if (col === "totalDeliveryAmount") {
                        let totalDeliveryAmount = "";
                        if(!Utils.isEmpty(result["totalDeliveryAmount"]) && result["totalDeliveryAmount"] != null){
                            totalDeliveryAmount = Utils.number2digit(result["totalDeliveryAmount"]);
                        }
                        newTable[col] = totalDeliveryAmount;
                    }else if (col === "totalDineInAmount") {
                        let totalDineInAmount = "";
                        if(!Utils.isEmpty(result["totalDineInAmount"]) && result["totalDineInAmount"] != null){
                            totalDineInAmount = Utils.number2digit(result["totalDineInAmount"]);
                        }
                        newTable[col] = totalDineInAmount;
                    }else if (col === "totalTipPaid") {
                        let totalTipPaid = Utils.number2digit(result["totalTipPaid"]);
                        newTable[col] = totalTipPaid;
                    }else if (col === "customCharge") {

                        let customChargeObj = result["charge"];
                        if (!Utils.isEmptyObj(customChargeObj)){

                            let comp = "";
                            for (var key in customChargeObj) {
                                if (customChargeObj.hasOwnProperty(key)) {
                                    let fee = Utils.number2digit(customChargeObj[key]);
                                    comp += key + ": $"+ fee + ",";
                                }
                            }

                            newTable[col] = comp;

                        }
                        else {
                            newTable[col] = null;
                        }

                    }else if (col === "lastOrderTotal") {
                        let lastOrderTotal = Utils.number2digit(result["lastOrderTotal"]);
                        newTable[col] = lastOrderTotal;
                    }else {
                        newTable[col] = result[col];
                    }

                });

                this.state.exportCustomersData.push(newTable);

            });

            const responseData = {
                error: false,
                Message: "Success",
                data: {
                    totalCount: customerResponseData.count
                }
            };
            return responseData
        }
        else {
            const responseData = {
                error: true,
                Message: "No data found",
                data: {}

            };
            return responseData
        }
    }

    showExportModal = () => {
        // disable the body scroll
        $("body").css('overflow', 'hidden');
        this.setState({
            showExportModal: true
        });
    }
    hideExportModal = () => {
        // enable the body scroll
        $("body").css('overflow', 'auto');
        this.setState({
            showExportModal: false,
            exportCustomersData  : [],
            exportLimit          : CONFIG_HELPER.DEFAULT_EXPORT_CUSTOMER_LIMIT,
            exportSkip           : 0,
            downloadCSVFile      : false,
            autoDownloadCSVFile  : false,
            progressBar          : false,
            errorMessage         : false,
            // completed            : 0,
        });
    }

    loadModalPopup = (rowVal) =>{
        $("body").css('overflow', 'hidden');
        this.setState({
            showModalPopUp: true,
            customerDetails: rowVal
        });
    }

    hideModalPopUp(){
        $("body").css('overflow', 'auto');
        this.setState({
            showModalPopUp: false
        });
    }

    render(){
        // get the orderReportData and header
        const csvData = this.state.exportCustomersData;
        const headers = headerColumns;

        columns["customerEmail"] = {
            ...columns.customerEmail,
            Cell: rowVal =>{

                let comp = "";
                if(!Utils.isEmptyObj(rowVal)){

                    comp = (
                        <span className="user_info">
                            <p>{rowVal.customerDetails.customerName}</p>
                            <p>{rowVal.customerDetails.customerEmail}</p>
                        </span>
                    )


                    return comp;
                }else{
                    return null
                }

            }
        }


        columns["customCharge"] = {
            ...columns.customCharge,
            Cell: rowVal => {

                let customChargeObj = rowVal.customCharge;

                if (!Utils.isEmptyObj(customChargeObj)){

                    let comp = "";
                    for (var key in customChargeObj) {
                        if (customChargeObj.hasOwnProperty(key)) {
                           let fee = Utils.number2digit(customChargeObj[key]);
                            comp += key + ": $"+ fee + "<br/>";
                        }
                    }

                    // return comp;
                    return <div dangerouslySetInnerHTML={{__html: comp}} />;

                }
                else {
                    return null;
                }

            }
        }

        columns["lastOrderDate"] = {
            ...columns.lastOrderDate,
            Cell: rowVal => {

                let orderDate = rowVal.lastOrderDate;
                let lastOrderDate = moment(orderDate.iso);

                // let date = moment(lastOrderDate).format("h:mm a, ddd,");
                let time = moment(lastOrderDate).format("MMM, YYYY")

                let comp = (
                    <span className="scheduled-comp">
                        #{rowVal.customerDetails.lastOrderNum}
                        <p>{time}</p>
                    </span>
                );

                return comp;

            }
        }

        columns["totalOrders"] = {
            ...columns.totalOrders,
            Cell: rowVal => {

                let totalOrders = rowVal.totalOrders;
                let comp = (
                    <span className="totalorder-comp">
                        <p>{totalOrders}</p>
                    </span>
                );

                return comp;

            }
        }

        columns["orderTotal"] = {
            ...columns.orderTotal,
            Cell: rowVal => {
                let orderTotal = rowVal.orderTotal;
                let comp = (
                    <span className="totalorder-comp">
                        <p>${orderTotal}</p>
                    </span>
                );

                return comp;

            }
        }

        columns["customerDetails"] = {
            ...columns.customerDetails,
            Cell: rowVal => (
                <button style={{cursor:'pointer'}}
                    type="button"
                    className="btn btn-link search-order-details"
                    onClick={_ => this.loadModalPopup(rowVal)}
                >
                    {/* <i className="fa fa-search" aria-hidden="true"></i> */}
                    <img src={Search_Icon} alt="" height="25" width="23"/>
                    {/* Show */}
                </button>)
        }

        return (
        <div className = "order-pg">
            { !this.state.isLoaded ? <Spinner /> : null }
            <div className="">
                <div className="col-md-12 text-center">
                    <label className="p-small">This page shows user statistics for a location.</label>
                </div>
            </div>
            <div className="">
                <div className="col-md-6 remove-left-padding">
                    <h4>Total of {this.state.totalCustomersCount} customers</h4>
                </div>
                <div className="col-md-6 remove-right-padding">
                    <div className={"export-button"}>
                        <button className={"btn btn-primary"}
                                onClick={this.exportCustomerReport}
                                style={{marginBottom: '10px'}}>
                            <i className="fa fa-file-excel-o" aria-hidden="true"></i> Export as CSV
                        </button>
                    </div>
                </div>
            </div>
            {
                this.state.showExportModal ?
                    <Modal
                    show={this.state.showExportModal}
                    closeCallback={this.hideExportModal}
                    customClass="custom_modal_class"
                    headerCustomClass={"modal-header-custom"}
                    title={"Export Customer Report"}>
                        <div className={""}>
                            <div className="section export-order-container">
                                <div className="container" style={{maxWidth: '100%'}}>

                                    {
                                        this.state.progressBar ?
                                            <div>
                                                <h4>Exporting customers reports...</h4>
                                                <LinearProgress color={"blue"}/>

                                            </div> : null
                                    }
                                    {
                                        this.state.errorMessage ?
                                            <div className={"export-download-container"}>
                                                <h4>No search data found<br/><br/>
                                                    <br/>
                                                </h4>
                                            </div> : null
                                    }
                                    {
                                        this.state.autoDownloadCSVFile ?
                                            <CSVDownload data={csvData}
                                                         headers={headers}/> : null
                                    }
                                    {
                                        this.state.downloadCSVFile ?
                                            <div className={"export-download-container"}>Your export
                                                is ready. If you don't see your file,
                                                <CSVLink data={csvData}
                                                         filename={this.state.CSVfileName + ".csv"}
                                                         className="btn btn-link"
                                                         headers={headers}>You can try downloading
                                                    it again.
                                                </CSVLink>
                                            </div>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                </Modal> : null
            }

            {
                this.state.showModalPopUp ?
                    <Modal
                        show={this.state.showModalPopUp}
                        closeCallback={this.hideModalPopUp}
                        customClass="customerinfo_modal_class"
                        headerCustomClass={"modal-header-custom"}
                        title={"Customer Details"}
                        order={this.state.order}

                    >
                        <div className={"row"}>

                            <CustomerDetail
                                customersData={this.state.customerDetails}
                            />

                        </div>
                    </Modal> : null
            }
            <div className="col-md-12">
            {
                this.state.totalCustomersCount > 0 ?
                    <TableHolderCustom
                        columns={columns}
                        tableData={this.state.customersData}
                        isPrevBtnActive={this.state.isPrevBtnActive}
                        isNextBtnActive={this.state.isNextBtnActive}
                        btnPrevClick={this.btnPrevClick}
                        btnNextClick={this.btnNextClick}
                        countDefault={this.state.skip}
                        pagination={this.state.pagination}
                        customClass={"consumer-details"}
                    /> :
                    <div className="col-md-12 text-center">
                        <h4 className="h-small">No record found
                        </h4>
                    </div>
            }
            </div>
        </div>
        );
    }

}





// WEBPACK FOOTER //
// src/components/visualization/userstats2-table.js